(function (Drupal) {
  'use strict';

  let initialized = false,
  navElements = {};


  const tabTrap = (element) => {
    var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="submit"]:not([disabled]) , input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener('keydown', function(e) {
      var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

      if (!isTabPressed) {
        return;
      }

      if ( e.shiftKey ) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
            e.preventDefault();
          }
        } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
            e.preventDefault();
          }
        }
    });
  };

  // The mega menu is always besides the button, so set aria label
  const setSiblingButton = (e, state) => {
    let parent = e.parentNode;
    let button = parent.querySelector('button');
    if(button){
      button.setAttribute('aria-expanded', state);
    }
  };

  const hide = (e) => {
    e.classList.remove('menu-dropdown--opened');
    setSiblingButton(e, false);
  };

  const show = (e) => {
    e.classList.add('menu-dropdown--opened');
    setSiblingButton(e, true);
    tabTrap(e);
  };

  const openMenu = (e) => {
    navElements.mainNav.classList.remove('header--short');
    navElements.mainNav.classList.add('megamenu-open');
    show(e);
  };

  const closeMenu = (e) => {
    navElements.mainNav.classList.remove('megamenu-open');
    hide(e);
  };

  const openMobileSubMenu = (e) => {
    navElements.mobileMainSubmenu.classList.add("menu-sub--opened"); // Currently does nothing but may use it for accebility
    e.classList.add('sub-menu-open');
    setSiblingButton(e, true);
    tabTrap(e);
  };

  const closeSubMenu = (e) => {
    navElements.mobileMainSubmenu.classList.remove("menu-sub--opened");
    e.classList.remove('sub-menu-open');
    setSiblingButton(e, false);
  };

  const registerSubMenuClickEvent = (e) => {
    let menu = e.currentTarget.childDropdownMenu;
    if (e.target !== menu && !menu.contains(e.target) && !e.target.classList.contains('menu-open')) {
      closeMenu(menu);
      let mainNavLink = document.querySelector('.menu-open');
      if (mainNavLink) {
        mainNavLink.classList.remove('menu-open');
      }
    }
  };

  const handleNavUpdate = () => {
    let mobileNavMenu = navElements.mobileNav.querySelector('.nav--mobile--menu');

    if (mobileNavMenu.style.display !== 'none' && !mobileNavMenu.classList.contains('mobile-menu-open')) {

      if (window.scrollY > scrollAmt()) {

        //if admin menu is open
        if(document.querySelector('#toolbar-bar') && document.querySelector('#toolbar-item-administration-tray.is-active.toolbar-tray-horizontal')){
          navElements.mainNav.classList.add('header--stick-to-top-admin-full');
        }else if(document.querySelector('#toolbar-bar')){
          navElements.mainNav.classList.add('header--stick-to-top-admin-small');
        }else {
          navElements.mainNav.classList.add('header--stick-to-top');
        }

        if (!navElements.mainNav.classList.contains('megamenu-open')) {
          navElements.mainNav.classList.add('header--short');
        }

        if (!navElements.mainNav.classList.contains('no-hero')) {
          navElements.mainNav.classList.add('header--white');
        }

      } else {

        navElements.mainNav.classList.remove('header--stick-to-top');
        navElements.mainNav.classList.remove('header--stick-to-top-admin-small');
        navElements.mainNav.classList.remove('header--stick-to-top-admin-full');
        navElements.mainNav.classList.remove('header--short');

        if (!navElements.mainNav.classList.contains('no-hero')) {
          navElements.mainNav.classList.remove('header--white');
        }

      }
    }
  };

  function scrollAmt(){
    let scrollAmt = 20;

    if (document.querySelector('#sitewide-alert') && document.querySelector('#sitewide-alert').length > 0) {
      let sitewideAlertHeight = document.querySelector('#sitewide-alert').offsetHeight;

      let adminMenuBlack = document.querySelector('#toolbar-bar');
      let adminMenuBlackHeight = 0;
      if(adminMenuBlack){
        adminMenuBlackHeight = adminMenuBlack.offsetHeight;
      }

      let adminMenuGrey = document.querySelector('#toolbar-item-administration-tray.is-active.toolbar-tray-horizontal');
      let adminMenuGreyHeight = 0;
      if(adminMenuGrey){
        adminMenuGreyHeight = adminMenuGrey.offsetHeight;
      }

      if(sitewideAlertHeight > 0 && (adminMenuGreyHeight > 0 || adminMenuBlackHeight > 0)){
        scrollAmt = sitewideAlertHeight + adminMenuBlackHeight + adminMenuGreyHeight;
      } else if(sitewideAlertHeight > 0){
        scrollAmt = sitewideAlertHeight;
      }
    }

    return scrollAmt;
  }

  const initNav = () => {
    if (!initialized) {
      navElements = {
        'mainNav': document.querySelector('header'),
        'topNav': document.querySelector('.topbar-wrapper'),
        'mobileNav': document.querySelector('nav.menu--main-navigation-mobile'),
        'mobileMainSubmenu': document.querySelector('nav.menu--main-navigation-mobile ul.menu-level-1')
      };

      const emptyElement = Object.values(navElements).some(x => (x === null));
      if (!emptyElement) {
        initialized = true;
      } else {
        return;
      }

      handleNavUpdate();
    }
  };

  Drupal.behaviors.mainNav = {
    attached: false,

    attach: function (context, settings) {
      // this prevents the attach running multiple times when the user is logged in
      if (this.attached) { return; }
      this.init();
      this.attached = true;
    },

    init: function (context, settings) {
      initNav();

      // Handles nav updates when scrolling vs top of page
      window.addEventListener('scroll', handleNavUpdate, false);

      // Main Navigation DESKTOP click / dropdown functionality
      let mainNavLinks = document.querySelectorAll('.js-toggle-megaMenu');
      if (mainNavLinks !== null) {
        mainNavLinks.forEach(function (mainNavLink) {
          mainNavLink.addEventListener('click', function() {

            let childDropdownMenu = this.closest('.menu-item').querySelector('.menu-dropdown');

            // Hide all other opened menus
            document.querySelectorAll('.menu-dropdown--opened').forEach(function (dropdownMenu) {
              hide(dropdownMenu);
            });
            mainNavLinks.forEach(function (mainNavLink) {
              mainNavLink.classList.remove('menu-open');
            });


            document.removeEventListener("click", registerSubMenuClickEvent, false);
            if (!childDropdownMenu.classList.contains('menu-dropdown--opened')) {
              mainNavLink.classList.add('menu-open');
              openMenu(childDropdownMenu);
              document.childDropdownMenu = childDropdownMenu;
              document.addEventListener("click", registerSubMenuClickEvent, false);
            } else {
              closeMenu(childDropdownMenu);
              mainNavLink.classList.remove('menu-open');
              document.childDropdownMenu = {};
            }
          });
        });
      }

      let menuCloseBtns = document.querySelectorAll('button.menu-close-btn');
      if (menuCloseBtns !== null) {
        menuCloseBtns.forEach(function (menuCloseBtn) {
          menuCloseBtn.addEventListener('click', function() {
            let allMegaMenu = document.querySelectorAll('.menu-dropdown');
            allMegaMenu.forEach((menu) => {
              closeMenu(menu);
            });
            let alljsLinks = document.querySelectorAll('.js-toggle-megaMenu');
            alljsLinks.forEach((link) => {
              link.classList.remove('menu-open');
            });

            this.closest('.menu-item').querySelector('button').focus();

          });
        });
      }


      // MOBILE OPEN
      let mobileMenuBtn = document.querySelector('.js-open-menu');
      if (mobileMenuBtn !== null) {
        let mobileNavTopMenu = navElements.mobileNav.querySelector('ul.menu-level-1');
        mobileMenuBtn.addEventListener('click', function () {
          this.classList.toggle('mobile-menu-open');

          if (mobileMenuBtn.classList.contains('mobile-menu-open')) {
            this.setAttribute('aria-expanded', true);
            navElements.mainNav.classList.add('header--white');
            navElements.mainNav.classList.add('header--stick-to-top');
            navElements.mainNav.classList.remove('header--short');
            mobileNavTopMenu.classList.add('menu--opned');

          }
          else {

            if (window.scrollY < scrollAmt() && !navElements.mainNav.classList.contains('no-hero')) {
              navElements.mainNav.classList.remove('header--white');
              navElements.mainNav.classList.remove('header--stick-to-top');
              navElements.mainNav.classList.remove('header--short');
            }

            if (window.scrollY > scrollAmt()) {
              navElements.mainNav.classList.add('header--short');
            }

            mobileNavTopMenu.classList.remove('menu--opned');
            this.setAttribute('aria-expanded', false);
            let subMenus = document.querySelectorAll('.menu-level-2.sub-menu-open');
            subMenus.forEach(function (subMenu) {
              closeSubMenu(subMenu);
            });
          }
        });


        // Close mobile menu when the use tabs outside of it!
        navElements.mobileNav.addEventListener('focusout', function(e) {

          // Make related target is not null ( this only happens when you inspect the element)
          if( e.relatedTarget && !navElements.mobileNav.contains(e.relatedTarget) && !e.target.classList.contains('nav--mobile--return-btn')) {
            mobileMenuBtn.classList.remove('mobile-menu-open');
            mobileMenuBtn.setAttribute('aria-expanded', false);
            if (window.scrollY < scrollAmt() && !navElements.mainNav.classList.contains('no-hero')) {
              navElements.mainNav.classList.remove('header--white');
              navElements.mainNav.classList.remove('header--stick-to-top');
              navElements.mainNav.classList.remove('header--short');
            }

            if (window.scrollY > scrollAmt()) {
              navElements.mainNav.classList.add('header--short');
            }

            mobileNavTopMenu.classList.remove('menu--opned');
            let subMenus = document.querySelectorAll('.menu-level-2.sub-menu-open');
            subMenus.forEach(function (subMenu) {
              closeSubMenu(subMenu);
            });
          }
        });
      }

      let mobileNavLinks = document.querySelectorAll('nav.menu--main-navigation-mobile li.menu-item-level-1.has-children');
      if (mobileNavLinks !== null) {
        mobileNavLinks.forEach(function (mobileNavLink) {
          mobileNavLink.addEventListener('click', function() {
            let subMenu = this.querySelector('ul.menu-level-2');
            openMobileSubMenu(subMenu);
            setTimeout(function(){
              subMenu.querySelectorAll('button, a')[0].focus();
            },50);
          });
        });
      }

      let mobileMenuReturnButton = document.querySelectorAll('nav.menu--main-navigation-mobile button.nav--mobile--return-btn');
      if (mobileMenuReturnButton !== null) {
        mobileMenuReturnButton.forEach(function (returnButton) {
          returnButton.addEventListener('click', function(e) {
            let subMenu = this.closest('ul.sub-menu-open');
            subMenu.parentNode.querySelector('button').focus(); // Focus on the button that opened the submenu
            closeSubMenu(subMenu);
            e.preventDefault();
            e.stopPropagation();
          });
        });
      }
    }
  };

  Drupal.behaviors.search = {
    initialized: false,
    attach: function (context, settings) {
      // Get search container
      const search_container = document.querySelector('.js-search-container');
      const search_container_mobile = document.querySelector('.js-search-container-mobile');

      if (
        !Drupal.behaviors.search.initialized &&
        typeof search_container !== 'undefined' && search_container !== null && search_container.length > 0 &&
        typeof search_container_mobile !== 'undefined' && search_container_mobile !== null && search_container_mobile.length > 0
      ) {
        return false;
      }

      // Set Initialized a true.
      Drupal.behaviors.search.initialized = true;

      // Get search main button, attach click listener
      const search_open = context.querySelector('.js-search-open');
      if (typeof search_open !== 'undefined' && search_open !== null) {
        search_open.addEventListener('click', function (e) {
          e.preventDefault();
          // Focus search input
          window.setTimeout(function () {
            const search_input = document.querySelector('.block-header__search__container .form-type-search .form-search');
            search_input.focus();
            tabTrap(search_container);
          }, 0);
          search_container.classList.toggle('is-active');

          if (search_container.classList.contains('is-active')) {
            search_open.setAttribute("aria-expanded", true);
          } else {
            search_open.setAttribute("aria-expanded", false);
          }
        });
      }

      // Get search mobile button, attach click listener.
      const search_open_mobile = context.querySelector('.js-search-open-mobile');
      if (typeof search_open_mobile !== 'undefined' && search_open_mobile !== null) {
        search_open_mobile.addEventListener('click', function (e) {
          e.preventDefault();

          // Close hamburger menu.
          const hamburgerMenu = document.querySelector('.before-icon.before-icon__hamburger.nav--mobile--menu.js-open-menu.mobile-menu-open');
          if (typeof hamburgerMenu !== 'undefined' && hamburgerMenu !== null) {
            hamburgerMenu.click();
          }

          // Focus search input.
          window.setTimeout(function () {
            const search_input_mobile = document.querySelector('.block-header__search__container-mobile .form-type-search .form-search');
            search_input_mobile.focus();
            tabTrap(search_container_mobile);
          }, 0);

          search_container_mobile.classList.toggle('is-active');

          if (search_container_mobile.classList.contains('is-active')) {
            search_open_mobile.setAttribute("aria-expanded", true);
          } else {
            search_open_mobile.setAttribute("aria-expanded", false);
          }
        });
      }

      // Get search close button, attach click listener.
      const search_close = context.querySelector('.js-search-close');
      if (typeof search_close !== 'undefined' && search_close !== null) {
        search_close.addEventListener('click', function (e) {
          e.preventDefault();
          search_container.classList.remove('is-active');
          search_open.setAttribute("aria-expanded", false);
          search_open.focus(); // Set the focus back to the search button after closing.
        });
      }

      // Get search mobile close button, attach click listener.
      const search_close_mobile = context.querySelector('.js-search-close-mobile');
      if (typeof search_close_mobile !== 'undefined' && search_close_mobile !== null) {
        search_close_mobile.addEventListener('click', function (e) {
          e.preventDefault();
          search_container_mobile.classList.remove('is-active');
          search_open_mobile.setAttribute("aria-expanded", false);
          search_open_mobile.focus(); // Set the focus back to the search button after closing.
        });
      }

      // Detect click outside buttons and element.
      document.addEventListener('click', function (e) {
        if (search_open) {
          var click_search_button = search_open.contains(event.target);
          var click_search_container = search_container.contains(event.target);

          if (!click_search_button && !click_search_container) {
            search_container.classList.remove('is-active');
            search_open.setAttribute("aria-expanded", false);
          }
        }
      });

      document.addEventListener('click', function (e) {
        if (search_open_mobile) {
          var click_search_button = search_open_mobile.contains(event.target);
          var click_search_container = search_container_mobile.contains(event.target);

          if (!click_search_button && !click_search_container) {
            search_container_mobile.classList.remove('is-active');
            search_open_mobile.setAttribute("aria-expanded", false);
          }
        }
      });
    }
  };

}(Drupal));
